import * as React from 'react';
import cx from 'classnames';
import throttle from 'lodash/throttle';
import styles from './DropDownMenuStyle.css';
import { identifyPosition } from './DropDownPositionUtil';
export var DropDownPosition;
(function (DropDownPosition) {
    DropDownPosition["RIGHT"] = "right";
    DropDownPosition["LEFT"] = "left";
    DropDownPosition["CENTER"] = "center";
})(DropDownPosition || (DropDownPosition = {}));
export var VerticalPosition;
(function (VerticalPosition) {
    VerticalPosition["TOP"] = "top";
    VerticalPosition["BOTTOM"] = "bottom";
})(VerticalPosition || (VerticalPosition = {}));
export default class DropDownMenu extends React.Component {
    constructor(props) {
        super(props);
        this.handleEscape = (event) => {
            if (event.keyCode === 27) {
                this.setState({ active: false });
            }
        };
        this.handleResize = () => {
            this.setInitialProps(this.props);
            this.innerHeight = window.innerHeight;
        };
        this.tooltipRef = (c) => (this.tooltip = c);
        this.itemRef = (c) => (this.itemText = c);
        this.setInitialProps(props);
        this.state = {
            active: props.active || false // user can control if this needs to be active or not.
        };
        this.hasKeyUpEvent = false;
        this.handleResize = throttle(this.handleResize.bind(this));
        this.handleResize();
    }
    setInitialProps(props) {
        this.position = props.position || DropDownPosition.CENTER;
        this.verticalPosition = props.verticalPosition || VerticalPosition.BOTTOM;
        this.boxRect = null;
    }
    componentDidMount() {
        const { onShow, onHide } = this.props;
        window.addEventListener('resize', this.handleResize);
        if (this.state.active) {
            this.state.active ? typeof onShow !== 'undefined' && onShow() : typeof onHide !== 'undefined' && onHide();
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        return (this.props.children !== nextProps.children ||
            this.state.active !== nextState.active ||
            this.props.content !== nextProps.content);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setInitialProps(nextProps);
        this.setState({ active: !!nextProps.active });
    }
    componentDidUpdate(prevProps) {
        let previousState = Boolean(prevProps.active);
        if (this.state.active !== previousState) {
            const { onShow, onHide } = this.props;
            this.state.active ? typeof onShow !== 'undefined' && onShow() : typeof onHide !== 'undefined' && onHide();
        }
    }
    componentWillUnmount() {
        this.hasKeyUpEvent && window.removeEventListener('keyup', this.handleEscape);
        window.removeEventListener('resize', this.handleResize);
    }
    renderContent() {
        const { children, verticalPosition, contentMaxWidth, fixPosition, showArrow } = this.props;
        if (!this.boxRect && !fixPosition) {
            this.boxRect = this.itemText && this.itemText.getBoundingClientRect();
        }
        const minPadding = 32;
        const position = fixPosition
            ? this.position
            : identifyPosition(this.boxRect, this.position, minPadding, contentMaxWidth);
        let tooltipClasses = cx(styles['tooltip'], styles['light'], this.props.tooltipClassName, styles[position], styles[verticalPosition], {
            [styles['active']]: this.state.active
        });
        return (<div ref={this.tooltipRef} className={tooltipClasses}>
				{showArrow && <div className={styles['arrow']}/>}
				<div className={styles['wrapper']}>
					<div className={this.props.containerClassName}>{children}</div>
				</div>
			</div>);
    }
    render() {
        const { content } = this.props;
        return (<div className={cx(styles['dropdown'], this.props.className)}>
				<div ref={this.itemRef} className={this.props.contentClassName}>
					{content || ' '}
				</div>
				{this.state.active ? this.renderContent() : null}
			</div>);
    }
}
DropDownMenu.defaultProps = {
    position: DropDownPosition.CENTER,
    verticalPosition: VerticalPosition.BOTTOM,
    showArrow: true,
    forceUpdatePosition: false,
    contentMaxHeight: 350,
    contentMaxWidth: 500,
    fixPosition: false
};
